export const routes = {
  home: {
    path: '/',
    exact: true
  },
  customerRequests: {
    path: '/customer-requests',
    exact: true
  },
  companyRequests: {
    path: '/company-requests',
    exact: true
  },
  assessment: {
    path: '/assessments/:id',
    exact: true
  },
  newRecord: {
    path: '/new/:id/:lang?',
    exact: true
  },
  newRecordSuccess: {
    path: '/new-success/:id/:lang?',
    exact: true
  },
  templateNotFound: {
    path: '/template-not-found',
    exact: true
  },
  logout: {
    path: '/logout',
    exact: true
  },
  notFound: {
    path: '*',
    exact: false
  }
};

export default routes;
